import { z } from 'zod';

import { uuidValidator } from '../../validators';

const QuizQuestionSchema = z.object({
  correctAnswer: z.string().nullable().optional(),
  imageUrl: z.string().url().optional().nullable(),
  question: z.any(), // Allow string for simple questions, object for complex ones
  type: z.string(),
  wordId: uuidValidator,
});

export type IQuizQuestionDto = z.infer<typeof QuizQuestionSchema>;

export const QuizResponseSchema = z.object({
  dynamic: z.array(QuizQuestionSchema),
  static: z.array(QuizQuestionSchema),
});

export interface IQuizQuestionsForWordDto {
  dynamic: IQuizQuestionDto[];
  static: IQuizQuestionDto[];
}

export interface IQuizResponseDto {
  [wordText: string]: IQuizQuestionsForWordDto;
}
